var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs-items',{attrs:{"touchless":"","value":_vm.activeTab}},_vm._l((_vm.sidebarTabs),function(item,index){return _c('v-tab-item',{key:index},[_c('keep-alive',[_c(item.component,{tag:"component"})],1)],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }